var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.4.152.9 3.656 6.4 7.16l5.5-3.504zM17.4.152l-5.5 3.505 5.5 3.504 5.5-3.504zM.9 10.664l5.5 3.504 5.5-3.504-5.5-3.503z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m17.4 7.16-5.5 3.505 5.5 3.504 5.5-3.504zM6.4 15.344l5.501 3.504 5.5-3.504-5.5-3.504z"
})));
export default SvgDropbox;